<template>
  <gg-card>
    <gg-card-header>
      Any other useful information
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-textarea label="Write anything you think is important about your business that you have not told us"
                      v-model="additional"
                      rows="4"
                      name="additional"
                      outlined
                      autocomplete="new-password"
                      data-vv-as="Additional"
                      :error-messages="errors.collect('additional')"></v-textarea>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'OtherInfo',
  computed: {
    ...mapGetters({
      model: 'wizard_model/starterSite'
    }),
    additional: {
      get () {
        return this.model.additional
      },
      set (val) {
        this.setAdditional(val)
      },
    },
  },
  methods: {
    ...mapMutations({
      setAdditional: 'wizard_model/SET_SS_ADDITIONAL',
    }),
  }
}
</script>
